import { ToastComponent } from "./component";

export const Toast = ToastComponent;
